import FeatureExample from './FeatureExample';
import { observer } from 'mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LightningId } from 'owa-lightning-v2';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';
import * as React from 'react';
import strings from 'owa-strings/owa-tasks-strings';

@observer
export default class FRE extends React.Component<{}, {}> {
    render() {
        return (
            <>
                {isFeatureEnabled('todo-drag-to-calendar') && (
                    <FeatureExample
                        lid={LightningId.TodoCalendarFRE}
                        when={lightup => getOwaWorkload() === OwaWorkload.Calendar && lightup()}
                        gif={require('../resources/DragToCalendar.gif')}
                        gifOverlayText={strings.dragToCalendarText}
                    />
                )}
                <FeatureExample
                    lid={LightningId.TodoMailFRE}
                    when={lightup => getOwaWorkload() === OwaWorkload.Mail && lightup()}
                    gif={require('../resources/DragInMail.gif')}
                    gifOverlayText={strings.dragInMailText}
                />
            </>
        );
    }
}
